import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface LeccionAprendida {
  id?: number;
  id_investigacion: number;
  id_siniestro: number;
  titulo: string;
  descripcion_leccion: string;
  recomendaciones?: string;
  mecanismo_divulgacion?: string;
  fecha_divulgacion?: string;
  poblacion_objetivo?: string;
  estado?: number;
}

@Injectable({ providedIn: "root" })
export class LeccionesAprendidasService {
  private apiUrl = `${environment.apiUrl}/api/lecciones-aprendidas`;

  constructor(private http: HttpClient) {}

  getByInvestigacionId(idInvestigacion: number | string): Observable<LeccionAprendida[]> {
    return this.http
      .get<LeccionAprendida[]>(`${this.apiUrl}/investigacion/${idInvestigacion}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getById(id: number | string): Observable<LeccionAprendida> {
    return this.http
      .get<LeccionAprendida>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: LeccionAprendida[]): Observable<LeccionAprendida[]> {
    return this.http
      .post<LeccionAprendida[]>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  update(id: number | string, payload: Partial<LeccionAprendida>): Observable<LeccionAprendida> {
    return this.http
      .put<LeccionAprendida>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  delete(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}